<style lang="stylus" scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
}

.demonstration {
  margin-right: 15px;
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.searchBtn {
  background: #41B883;
  color: #ffffff;
}

.carWrap {
// display: flex; // flex-direction: column; // padding: 20px; background: #fff;
  border-radius: 10px;

  main {
    flex: 1;
  }
}

.statiscs-time /deep/ .el-form-item__content {
  width: 140px;
}

.wrapper {
  padding: 20px;
  background: #fff;

  .header {
  //margin-bottom: 20px; margin-top: 20px;
  }
}
</style>
<template>
  <div>
  <div class="wrapper">
    <div style="font-weight: bold;margin-bottom: 20px" v-if="!showTop100Company">加能站明细</div>
    <dimension-dialog v-if="showExport" @hideExport="hideExport1" :oilBrand="oilBrand" :provinceName="provinceNames"
                      :params="params" :cityName="cityName" :moduleName="moduleName"
                      :beforeExportFunc="beforeExportFunc"/>
    <div style class="carWrap">
      <Top100CompanyTable :id="poiId" @on-close="showTop100Company = false" v-if="showTop100Company" :dimObj="dimObj"/>
      <div v-show="!showTop100Company">
        <div class>
          <el-form :inline="true">
            <el-form-item label="统计时间" class="statiscs-time">
              <dimension-popover :isMapValue="true" :dimObj="dimObj" :change="changeDimension" :showBottomButton="false"
                                 :isItemBindClick="true"/>
            </el-form-item>
            <el-form-item label="省市区" label-width="100px">
              <!--            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>-->
                          <el-cascader
                              v-if="areaListPr.length>0"
                :options="areaListPr"
                v-model="formData.provCityCounty"
                :props="propsData()"
                collapse-tags
                filterable
                :before-filter="filterMethod"
                clearable></el-cascader>
            </el-form-item>
            <template v-if="value1">
              <el-form-item label="站点名称" label-width="75px">
                <el-input v-model="formData.stationName" clearable placeholder="请输入站点名称"></el-input>
              </el-form-item>
              <el-form-item label="站点类型" label-width="75px">
                <el-select v-model="formData.zhanDianType" multiple
                           collapse-tags placeholder="请选择">
                  <el-option
                      v-for="item in zhanDianOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="站点品牌" label-width="75px">
                <el-select v-model="formData.zhanDianBrand" multiple
                           collapse-tags placeholder="请选择">
                  <el-option
                      v-for="item in zhanDianBrandOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="吨位区间" label-width="75px">
                <el-select v-model="formData.dunwei" multiple
                           collapse-tags placeholder="请选择">
                  <el-option
                      v-for="item in dunWeiOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="燃料类型" label-width="75px">
                <el-select v-model="formData.ranliaoType" multiple
                           collapse-tags placeholder="请选择">
                  <el-option
                      v-for="item in ranliaoOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
            <!--            <el-form-item label="省份">-->
            <!--              <el-select v-model="provinceNames" placeholder="请选择省份" @change="getCityList">-->
            <!--                <el-option label="全部" value></el-option>-->
            <!--                <el-option v-for="item in areaList" :label="item.provinceName" :value="item.provinceName" :key="item.provinceName"></el-option>-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="地区">-->
            <!--              <el-select v-model="cityName" placeholder="请选择地区" @change="getCityName">-->
            <!--                <el-option label="全部" value></el-option>-->
            <!--                <el-option v-for="item in cityData" :label="item.cityName" :value="item.cityName" :key="item.cityName"></el-option>-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="品牌">-->
            <!--              <el-select v-model="oilBrand" placeholder="请选择品牌" @change="getBrandCode">-->
            <!--                <el-option v-for="item in titleArr" :label="item.name" :value="item.name" :key="item.name"></el-option>-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->
            <el-form-item style="margin-left: 20px;">
              <el-button @click="submitData" class="searchBtn">查询</el-button>
              <el-button @click="goback">返回上级</el-button>
              <el-button v-show="hideExport" style="margin-left:10px;" @click="exportData">导出查询结果</el-button>
              <el-button v-show="hideExport" @click="exportDate">导出全部明细</el-button>
              <el-switch
                  v-model="value1"
                  style="margin-left: 10px"
                  active-text="展开"
                  @change="changeSearch"
                  inactive-text="收起">
              </el-switch>
            </el-form-item>
          </el-form>
        </div>
        <main>
          <Table @on-to-stop-detail="onToStopDetailTop100Company" :heightSet="heightSet" :allData="allData"/>
        </main>
        <div class="block" style="width: fit-content; margin-left: auto; margin-right: auto;">
          <el-pagination @current-change="changeData" :current-page.sync="currentPage" :page-size="pageSize"
                         layout="prev, pager, next, jumper" :total="total" slot="pagin"></el-pagination>
        </div>
      </div>
    </div>

  </div>
  <div class="bottom-top" v-if="!showTop100Company">
    <h4>
      <img src="../../../../assets/images/title.png"/>
      <span>说明</span>
    </h4>

    <div>1.省市区：可逐级选择，或输入关键词模糊搜索。筛选项支持多选。</div>
    <div>2.站点类型：①加油站：仅支持加油；②加气站：仅支持加气；③加氢站：仅支持加氢；④加油加气站：同时支持加油和加气。筛选项支持多选。</div>
    <div>3.吨位区间：以车辆总质量的吨位数进行区间划分。筛选项支持多选。</div>
    <div>4.燃料类型：根据车辆燃料类型进行划分。筛选项支持多选。</div>
    <div>5.站前流量：车辆途经加能站附近导航距离500米道路的次数汇总。【注】一辆车一天途经多次计为一次。</div>
    <div>6.站内停靠：统计区域加能站车辆停靠次数。【注】一辆车在同个加能站一天停靠多次计为一次；停靠统计时长范围为3分钟-2小时。</div>
    <div>7.进站率：站内停靠÷站前流量。</div>
    <div>8.统计频率：按月统计，每月6日更新上月数据。</div>
    <div>9.下一级页面：点击具体站点名称，进入“对应加能站停靠次数TOP100企业情况”页面。</div>
    <div>【注】如您发现某个加能站相关信息需要更新，请联系省级管理员或中交兴路顾问。</div>

  </div>
    <div class="bottom-top" v-if="showTop100Company">
      <h4>
        <img src="../../../../assets/images/title.png"/>
        <span>说明</span>
      </h4>

      <div>1.不同车辆停靠次数：该企业名下不同燃料类型车辆在该加能站的停靠次数统计。</div>
      <div>2.企业总车辆区间：按该企业名下车辆数进行等级划分。A：100辆及以上；B：50-99辆；C：20-49辆；D：10-19辆；E：少于10辆。</div>
      <div>3.不同车辆占比：该企业名下不同燃料类型的车辆数÷该企业名下车辆总数。</div>
      <div>4.统计频率：按月统计，每月6日更新上月数据。</div>
      <div>【注】因涉及企业敏感数据，该页面数据不支持导出。</div>
    </div>
  </div>
</template>
<script>
import Table from './components/table' // 表格数据
import http from '@/api/freight.js' //请求汇总
import exportDate from '@/components/exportDate/index'
import {hideExport, mergeTree} from '@/utils/tools'
import {
  getGasStationDropBox,
  getGasStationLabelByBrand,
} from '@/utils/dictionary'
import dimensionDialog from '@/components/exportDate/daphne/dialog.vue'
import dimensionPopover from '@/components/exportDate/daphne/popover.vue'
import Top100CompanyTable from './components/top100CompanyTable.vue'
import get from 'lodash/get'
import Util from "utils/util";
import Cookies from "js-cookie";
import {exportOilStationBerthSimplify, progress} from "api/log";

var now = new Date()
now.setMonth(now.getMonth() - 1)
export default {
  components: {
    Table,
    exportDate,
    dimensionDialog,
    dimensionPopover,
    Top100CompanyTable
  },
  props: {
    areaList: Array,
    provinceName: String,
    pathWayCityName: String,
    brandName: String,
    dimObj: {
      default: () => {
        return {
          year: '2022',
          month: '02',
          type: '0',
        }
      },
      type: Object,
    },
  },
  data() {
    let titleArr = getGasStationDropBox()
    return {
      value1: true,
      ranliaoOption: Util.ranLiaoOption,
      dunWeiOption: Util.dunWeiOption,
      zhanDianOption: Util.zhanDianOption,
      zhanDianBrandOption: Util.zhanDianBrandOption,
      areaListPr: [],
      heightSet: this.tableHeight + 30,
      params: {},
      formData: {
        stationName: '',
        provCityCounty: [],
        ranliaoType: [],
        zhanDianType: [],
        zhanDianBrand: [],
        dunwei: [],
      },
      hideExport: hideExport,
      moduleName: 'oilStationBerthDetailV2',
      showExport: false,
      cityData: [],
      /*titleArr: [
        { name: '所有油站', code: 0 },
        { name: '中国石油', code: 1 },
        { name: '中国石化', code: 2 },
        { name: '其他油站', code: 3 }
      ],*/
      titleArr,
      oilBrand: '',
      cityName: '',
      provinceNames: '',
      progressNum: 0, // 导出下载进度条
      currentPage: 1,
      total: 0,
      pageSize: 20,
      allData: [], // 总数据
      showTop100Company: false,
      poiId: '',
    }
  },
  async created() {
    if (this.provinceName) {
      this.provinceNames = this.provinceName
      this.isPrivice(this.provinceName)
    }
    this.cityName = this.pathWayCityName
    this.oilBrand = this.brandName

    if (this.$route.query.year && this.$route.query.month) {
      this.dimObj.year = this.$route.query.year;
      this.dimObj.month = this.$route.query.month
      this.dimObj.type = this.$route.query.type
    }
    await this.getPrInter()
    if (this.$route.query.provCityCounty){
      console.log(this.$route.query.provCityCounty)
      this.formData.provCityCounty = this.$route.query.provCityCounty
      this.showValue()
    }
    this.initData()
  },
  methods: {
    showValue() {
      this.regionId = this.$route.query.provCityCounty
      if (this.regionId && this.regionId.length > 0) {
        // 处理多选数据，如果是单个选择项，转换为二维数组
        if (Array.isArray(this.regionId[0])) {
          // 已经是二维数组
          this.formData.provCityCounty = this.regionId
        } else {
          // 一维数组，转换为二维数组
          this.formData.provCityCounty = [this.regionId]
        }
      }
      Promise.all(this.areaListPr.map(async item => {
        if (this.regionId && item.value == this.regionId[0]) {
          let children = await this.getCiInter(item.value)
          item.children = children
          await Promise.all(item.children.map(async childrenItem => {
            if (this.regionId.length > 1 && childrenItem.value == this.regionId[1]) {
              let subChildren = await this.getCuInter(childrenItem.value)
              childrenItem.children = subChildren
            }
            return childrenItem
          }))
        }
        return item
      })).then((data) => {
        this.areaListPr = data
      })
    },
    changeSearch() {
      if (this.value1) {
        this.heightSet = this.tableHeight - 30
      } else {
        this.heightSet = this.tableHeight + 30
      }
    },
    propsData() {
      const vm = this
      return {
        lazy: false,
        multiple: true,
        checkStrictly: true,
        expandTrigger: 'hover',
        async lazyLoad(node, resolve) {
          const {level, value} = node;
          if (vm.$route.query.provCityCounty && vm.$route.query.provCityCounty.includes(value)){
            resolve([])
          }else {
            if (level === 1) {
              resolve(await vm.getCiInter(value, level));
            } else if (level === 2) {
              resolve(await vm.getCuInter(value, level));
            } else {
              resolve([])
            }
          }
        }
      }
    },
    filterMethod(value) {
      return http
          .getCountyAreaListBySearch({keyword: value})
          .then(({data}) => {
            if (data.length !== 0) {
              const oldList = this.areaListPr || []
              const newList = data || []
              this.areaListPr = mergeTree(oldList, newList)
              return true // 允许 filter
            }
            return false // 阻止 filter
          })
    },
    async getPrInter() {
      // const {data} = await http.getCountyAreaList({code: '0', type: '1', areaType: 'PROVINCE'})
      // this.areaListPr = data
      //     .map(item => ({
      //       value: item.code,
      //       label: item.name,
      //       leaf: false
      //     }));
      // if (this.areaListPr.length == 1) {
      //   this.cardNum = Util.keyValueCardNum[this.areaListPr[0].value.substring(0, 2)]
      // }
      http
          .getCountyAreaListBySearch({keyword:''})
          .then(({data}) => {
            this.areaListPr = data
          })
    },
    getCiInter(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, type: '1', areaType: 'CITY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: code == '110000' || code == '120000' || code == '500000' || code == '310000' || code == '900000' ? true : false
            }));
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes);
      })
    },
    getCuInter(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, type: '1', areaType: 'COUNTY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: true
            }));
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes);
      })
    },
    getBrandCode(name) {
      this.oilBrand = name
    },
    goback() {
      this.$router.push({
        path: 'carStopNengBrand',
        query: {
          provCityCounty: this.saveprovCityCounty,
          saveprovCityCounty:this.$route.query.saveprovCityCounty
        }
      })
    },
    submitData() {
      this.currentPage = 1
      this.initData()
    },
    changeData() {
      let that = this
      this.initData()
    },
    isPrivice(e) {
      if (e) {
        let that = this
        http.getCityList({provname: e}).then((e) => {
          that.cityData = e.data
        })
      }
    },
    getCityList(e) {
      let that = this
      if (e) {
        http.getCityList({provname: e}).then((e) => {
          that.cityData = e.data
          that.cityName = ''
        })
      } else {
        this.cityData = []
        this.cityName = ''
      }
    },
    getCityName(e) {
      this.cityName = e
    },
    initData() {
      let that = this
      that.allData = []
      let provinceName = that.provinceNames
      let cityName = that.cityName
      //let oilBrand = that.oilBrand == '所有油站' ? '' : that.oilBrand
      let tmp = getGasStationLabelByBrand(that.oilBrand)
      let oilBrand = tmp === '所有油站' ? '' : tmp
      let page = this.currentPage
      let pageSize = this.pageSize
      console.log('---------------------111')
      console.log(this.formData.dunwei)
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      // 处理多选省市区数据，根据长度决定参数级别
      let provCodes = []
      let cityCodes = []
      let countyCodes = []

      if (this.formData.provCityCounty && this.formData.provCityCounty.length > 0) {
        this.formData.provCityCounty.forEach(item => {
          if (item && item.length > 0) {
            // 根据长度决定放到哪个级别，只添加最后一项
            if (item.length === 1) {
              provCodes.push(item[0])
            } else if (item.length === 2) {
              cityCodes.push(item[1])
            } else if (item.length === 3) {
              countyCodes.push(item[2])
            }
          }
        })
      }

      http
          .getDetailsList2({
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            year: this.dimObj.year,
            month: this.dimObj.month,
            stationTypes: this.formData.zhanDianType,
            tonnages: this.formData.dunwei,
            fuelTypes: this.formData.ranliaoType,
            kinds: this.formData.zhanDianBrand,
            stationName: this.formData.stationName,

            provCodes: provCodes,
            cityCodes: cityCodes,
            countyCodes: countyCodes,

            countTime: this.dimObj.year + '' + this.dimObj.month,
            // provinceName,
            // cityName,
            // oilBrand,
            // page,
            // pageSize,
            timeType: get(this, 'dimObj.type', '0'),
          })
          .then((e) => {
            loading.close();
            if (e.data) {
              this.total = e.data.total
              e.data.dataList.forEach((_) => {
                _.stationTypeText = this.getNmae(Util.stationType, _.stationType)
              })
              that.allData = [...e.data.dataList]
            }
          })
    },
    getNmae(allData, val) {
      let curr = allData.filter(item => {
        return item.value == val
      })
      if (curr.length > 0) {
        return curr[0].label
      } else {
        return '-'
      }
    },
    changeDimension(e) {
      if (e.isOk) {
        this.dimObj.year = e.year
        this.dimObj.month = e.month
        this.dimObj.type = e.type
      }
    },
    changeTime() {
      this.initData()
    },
    initMonth(num) {
      let newNum = num + 1
      return newNum < 10 ? '0' + newNum : newNum + ''
    },
    beforeExportFunc() {
      console.log(this.params)
      if (!this.params.cityCodes && !this.params.countyCodes && !this.params.provCodes) {
        this.$message({
          message: `请选择具体省份或城市进行油站信息导出`,
          type: 'warning'
        })
        return false
      }
      // if (!this.provinceNames) {
      //   this.$message({
      //     message: `请选择具体省份或城市进行油站信息导出`,
      //     type: 'warning'
      //   })
      //   return false
      // }
      return true
    },
    // 取消导出
    hideExport1() {
      this.showExport = false
    },
    exportData() {
      let that = this
      that.mark = true
      let reqId = Cookies.get('user')
      reqId += new Date() * 1
      let times
      times = setInterval(function () {
        progress({reqId}).then(e => {
          that.progressNum = e.data.percent
          if (e.data.percent >= 100) {
            clearInterval(times)
            that.progressNum = 100
            setTimeout(function () {
              that.mark = false
              that.progressNum = 0
            }, 500);
          }
        })
      }, 200)
      // 处理多选省市区数据，根据长度决定参数级别
      let provCodes = []
      let cityCodes = []
      let countyCodes = []

      if (this.formData.provCityCounty && this.formData.provCityCounty.length > 0) {
        this.formData.provCityCounty.forEach(item => {
          if (item && item.length > 0) {
            // 根据长度决定放到哪个级别，只添加最后一项
            if (item.length === 1) {
              provCodes.push(item[0])
            } else if (item.length === 2) {
              cityCodes.push(item[1])
            } else if (item.length === 3) {
              countyCodes.push(item[2])
            }
          }
        })
      }

      window.location.assign(
          exportOilStationBerthSimplify({
            reqId,
            year: this.dimObj.year,
            month: this.dimObj.month,
            stationTypes: this.formData.zhanDianType,
            tonnages: this.formData.dunwei,
            fuelTypes: this.formData.ranliaoType,
            kinds: this.formData.zhanDianBrand,
            dateType: this.dimObj.type,

            stationName:this.formData.stationName,

            provCodes: provCodes,
            cityCodes: cityCodes,
            countyCodes: countyCodes,

            countTime: this.dimObj.year + '' + this.dimObj.month,
            timeType: get(this, 'dimObj.type', '0'),
          })
      )
    },
    //导出
    exportDate() {
      // 处理多选省市区数据，根据长度决定参数级别
      let provCodes = []
      let cityCodes = []
      let countyCodes = []

      if (this.formData.provCityCounty && this.formData.provCityCounty.length > 0) {
        this.formData.provCityCounty.forEach(item => {
          if (item && item.length > 0) {
            // 根据长度决定放到哪个级别，只添加最后一项
            if (item.length === 1) {
              provCodes.push(item[0])
            } else if (item.length === 2) {
              cityCodes.push(item[1])
            } else if (item.length === 3) {
              countyCodes.push(item[2])
            }
          }
        })
      }

      this.params = {
        year: this.dimObj.year,
        month: this.dimObj.month,
        stationType: this.formData.zhanDianType,
        tonnage: this.formData.dunwei,
        fuelType: this.formData.ranliaoType,
        kind: this.formData.zhanDianBrand,

        provCodes: provCodes,
        cityCodes: cityCodes,
        countyCodes: countyCodes,

        countTime: this.dimObj.year + '' + this.dimObj.month,
        timeType: get(this, 'dimObj.type', '0'),
      }
      console.log(this.params)
      this.showExport = true
    },
    onToStopDetailTop100Company(poiId) {
      this.poiId = poiId
      this.showTop100Company = true
    }
  },
}
</script>
